import { Injectable } from '@angular/core';
import { Observable,Subject } from 'rxjs';
import { PortalProjectObject } from '../_models/project_portal_objects';
import { Companies,Users ,Projects,Objects,AccesObjects, UserAccessDetailsDTO, OrderUserValidationDTO, CopyUserAccess} from '../_models/admin';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PortalAdminService {

  constructor(private http: HttpClient) {
  }
  projectSubject: Subject<Projects> = new Subject<Projects>();
  selectedProject!: Projects ;

  setProject(project: Projects) {
    this.projectSubject.next(project);
    this.selectedProject = project;
   // this.titleService.setTitle('iDocs Admin Modules - ' + project.name);
}

getProject() {
    return this.projectSubject.asObservable();
}

  getCompanies(): Observable<Companies[]> {
    return this.http.get<Companies[]>(environment.apiUrl + `/companies`);
    // .pipe(
    //   tap(_ => this.logService.log(this.className, 'fetched projects'))
    // );
  }

  addCompanies(data:Companies){
    return this.http.post<Companies>(environment.apiUrl + `/companies`,data);
  }
  updateCompanies(companyid:number,data:Companies){
    return this.http.post<Companies>(environment.apiUrl + `/companies/${companyid}`,data);
  }

  deleteCompanies(companyid:number){
    return this.http.delete<Companies>(environment.apiUrl + `/companies/${companyid}`);
  }

  getUsers(): Observable<Users[]> {
    return this.http.get<Users[]>(environment.apiUrl + `/users`);

  }
  getLoginUsers(): Observable<Users> {
    return this.http.get<Users>(environment.apiUrl + `/users/loginuser`);

  }
  addUsers(data:Users){
    return this.http.post<Users>(environment.apiUrl + `/users`,data);
  }

  updateUsers(userid:number,data:Users){
    return this.http.post<Users>(environment.apiUrl + `/users/${userid}`,data);
  }

  deleteUsers(userid:number){
    return this.http.delete<Users>(environment.apiUrl + `/users/${userid}`);
  }

  getProjects(): Observable<Projects[]> {
    return this.http.get<Projects[]>(environment.apiUrl + `/projects`);

  }

  addProjects(data:Projects){
    return this.http.post<Projects>(environment.apiUrl + `/projects`,data);
  }

  updateProjects(projectid:number,data:Projects){
    return this.http.post<Projects>(environment.apiUrl + `/projects/${projectid}`,data);
  }

  deleteProject(projectid:number){
    return this.http.delete<Projects>(environment.apiUrl + `/projects/${projectid}`);
  }

  getObjects(projectid:number): Observable<Objects[]> {
    return this.http.get<Objects[]>(environment.apiUrl + `/projects/${projectid}/objects`);
  }

  getObjectsAll(projectid:number): Observable<Objects[]> {
    return this.http.get<Objects[]>(environment.apiUrl + `/projects/${projectid}/objects/all`);
  }

  addObject(projectid:number,data:Objects){
    return this.http.post<Objects>(environment.apiUrl + `/projects/${projectid}/objects`,data);
  }

  updateObject(projectid:number,id:number, data:Objects){
    return this.http.post<Objects>(environment.apiUrl + `/projects/${projectid}/objects/${id}`,data);
  }

  deleteObject(projectid:number,id:number){
    return this.http.delete<Objects>(environment.apiUrl + `/projects/${projectid}/objects/${id}`);
  }
  getObjectsAccess(projectid:number): Observable<AccesObjects[]> {
    return this.http.get<AccesObjects[]>(environment.apiUrl + `/projects/${projectid}/objectsaccess`);
  }

  addObjectAccess(projectid:number,data:AccesObjects){
    return this.http.post<AccesObjects>(environment.apiUrl + `/projects/${projectid}/objectsaccess`,data);
  }

  validateUserAccess(projectid:number,data:AccesObjects){
    return this.http.post<OrderUserValidationDTO[]>(environment.apiUrl + `/projects/${projectid}/objectsaccess/validate`,data);
  }

  addObjectAccessToAllOrders(projectid:number,data:AccesObjects){
    return this.http.post<AccesObjects>(environment.apiUrl + `/projects/${projectid}/objectsaccess/addall`,data);
  }

  overrideAndAddObjectAccessToAllOrders(projectid:number,data:AccesObjects){
    return this.http.post<AccesObjects>(environment.apiUrl + `/projects/${projectid}/objectsaccess/override`,data);
  }
  updateObjectAccess(projectid:number,accessid : number,data:AccesObjects){
    return this.http.post<AccesObjects>(environment.apiUrl + `/projects/${projectid}/objectsaccess/${accessid}`,data);
  }

  copyUserAccessOfUserToAnotherUser(data:CopyUserAccess){
    return this.http.post<AccesObjects>(environment.apiUrl + `/projects/user/copyaccess`,data);
  }

  copyUserAccessOfUserToAnotherUserAndOverrideExisting(data:CopyUserAccess){
    return this.http.post<AccesObjects>(environment.apiUrl + `/projects/user/copyaccess/override`,data);
  }

  validateUserAccessToCopy(data:CopyUserAccess){
    return this.http.post<OrderUserValidationDTO[]>(environment.apiUrl + `/projects/copyaccess/validate`,data);
  }

  deleteObjectAccess(projectid:number,accessid:number){
    return this.http.delete<Objects>(environment.apiUrl + `/projects/${projectid}/objectsaccess/${accessid}`);
  }

  deleteUserFromAllOrders(projectid:number,data:AccesObjects){
    return this.http.post<Objects>(environment.apiUrl + `/projects/${projectid}/objectsaccess/removeall`,data);
  }

  getUserAccessDetails(userid:number){
    return this.http.get<UserAccessDetailsDTO[]>(environment.apiUrl + `/users/get/accessdetails/${userid}`);
  }

}
